import axios from "axios";
import instance from "./controllerFetch";
const http = 'https://geoshop.netoip.com/geo/ac.php';
//const http = 'http://api.mpm.studiotrau.com/geo/ac.php';

class classZone {

    comuneLike = async (param) => {
        //console.log(param, ' param');
        const resp = await instance.get('zona/comuneLike', { params: param, responseType: 'json' })
        .then(function (response) { 
            return response
        })
        .catch(function (response) {
            //console.log(JSON.stringify(response ,false,2));
            return response
        })
        return resp
    }

    regioneLike = async (param) => {
        //console.log(param, ' param');
        const resp = await instance.get('zona/regioneLike', { params: param, responseType: 'json' })
        .then(function (response) {
            return response
        })
        .catch(function (response) {
            //console.log(JSON.stringify(response ,false,2));
            return response
        })
        return resp
    }

    provinciaLike = async (param) => {
       ////console.log(param, ' param');
        const resp = await instance.get('zona/provinciaLike', { params: param, responseType: 'json' })
        .then(function (response) {
            return response
        })
        .catch(function (response) {
            //console.log(JSON.stringify(response ,false,2));
            return response
        })
        return resp
    }

    nazioneLike = async (param) => {
       ////console.log(param, ' param');
        const resp = await instance.get('zona/nazioneLike', { params: param, responseType: 'json' })
        .then(function (response) {
            return response
        })
        .catch(function (response) {
            //console.log(JSON.stringify(response ,false,2));
            return response
        })
        return resp
    }

    provincia = async (param) => {
        const resp = await axios({
            method: 'get',
            url: http,
            responseType: 'json',
            params: {
                ...param ,
                tipo : 'prov'
            }

        })
        return resp
    }

    comune = async (param) => {
        const resp = await axios({
            method: 'get',
            url: http,
            responseType: 'json',
            params: {
                ...param ,
                tipo : 'comune'
            }

        })
        return resp
    }
    indirizzo  = async (param) => {
        const resp = await axios({
            method: 'get',
            url: http,
            responseType: 'json',
            params: {
                ...param ,
                tipo : 'indirizzo'
            }

        })
        return resp
    }
    civico  = async (param) => {
        const resp = await axios({
            method: 'get',
            url: http,
            responseType: 'json',
            params: {
                ...param ,
                tipo : 'civico'
            }

        })
        return resp
    }
  
   
  }
  
  export default new classZone();